module.exports = __webpack_public_path__ + "static/media/smileRating5.5ef394fd.svg";